import { APIS } from "../../components/constants/app.constant";
import { getResource, putResource } from "../axiosService";

export function getAllDetails(){
 const apiUrl = APIS.GET_ALL_DETAILS;
  return getResource(apiUrl);
}
export function getAllForms(){
  const apiUrl = APIS.GET_ALL_FORMS;
  return getResource(apiUrl);
}
export function finishOnBoarding(data){
  const apiUrl = APIS.FINISH_ONBOARDING;
  return putResource(apiUrl, data);
}